import React from 'react';
import { SETUP_SUBMODES } from '../../../../Services';
import '../../../styles/modes/setupMode.css';

/**
 * Submode Selector component for switching between map and manual input modes
 */
const SubmodeSelector = ({ 
  displaySubmode, 
  switchSubmode, 
  handleImportClick,
  fileInputRef,
  handleFileChange
}) => {
  return (
    <div className="setup-submode-selector">
      {Object.values(SETUP_SUBMODES).map(mode => (
        <button 
          key={mode}
          className={`submode-btn ${displaySubmode === mode ? 'active' : ''}`}
          onClick={() => switchSubmode(mode)}
        >
          {mode}
        </button>
      ))}
      <button 
        type="button" 
        className="submode-btn load-btn"
        onClick={handleImportClick}
      >
        Load Points
      </button>
      
      {/* Hidden file input */}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        accept=".json"
        onChange={handleFileChange}
      />
    </div>
  );
};

export default SubmodeSelector; 